import { useTranslation } from 'react-i18next';
import {
  PRODUCT_CAT_FILTER_ACTION_KEYS,
  PRODUCT_CAT_FILTER_FIELDS,
  type ProductCatFilterField,
} from '@/utils/productCatFilters';
import type { FeatureVisibilityConfig } from '@/services/featureVisibilityService';

interface ProductCatFiltersVisibilityEditorProps {
  value: FeatureVisibilityConfig;
  onChange: (next: FeatureVisibilityConfig) => void;
  disabled?: boolean;
}

export function ProductCatFiltersVisibilityEditor({
  value,
  onChange,
  disabled,
}: ProductCatFiltersVisibilityEditorProps) {
  const { t } = useTranslation();

  const setCatFilterEnabled = (field: ProductCatFilterField, enabled: boolean) => {
    onChange({
      ...value,
      actions: {
        ...value.actions,
        [`filters.${field}`]: { enabled },
      },
    });
  };

  const checkboxClass =
    'h-4 w-4 text-stocker-primary border-gray-300 rounded focus:ring-stocker-primary disabled:opacity-50';

  return (
    <div>
      <h3 className="text-sm font-semibold text-gray-800 mb-2">
        {t('settings.productCatFilters.title')}
      </h3>
      <p className="text-sm text-gray-500 mb-3">{t('settings.productCatFilters.description')}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {PRODUCT_CAT_FILTER_FIELDS.map((field) => {
          const actionKey = `filters.${field}`;
          const legacyEnabled =
            field === 'cat_1' ? value.actions?.['filters.category']?.enabled : undefined;
          const enabled =
            value.actions?.[actionKey]?.enabled ?? legacyEnabled ?? false;
          return (
            <label
              key={field}
              className="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
            >
              <input
                type="checkbox"
                className={checkboxClass}
                disabled={disabled}
                checked={enabled}
                onChange={(e) => setCatFilterEnabled(field, e.target.checked)}
              />
              <span>{t(`settings.productCatFilters.fields.${field}`)}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}

export { PRODUCT_CAT_FILTER_ACTION_KEYS };
